/**
 * Initials for an avatar that shows no name label: first letter of the first
 * and last words ("Natalia Andrade" → "NA"), the same rule design-elements'
 * `Avatar` uses when it derives initials from `name`.
 *
 * @param {string} [name]
 * @returns {string}
 */
export function getInitials(name) {
    const parts = typeof name === 'string' ? name.trim().split(/\s+/).filter(Boolean) : [];
    if (parts.length === 0) return '';
    const first = parts[0][0];
    const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return `${first}${last}`.toUpperCase();
}
